<template>
  <div class="header-content">
    <div class="header">
      <img src="@/assets/logo.png" alt="" class="logo-img" @click="toHome" />
      <Menu
        mode="horizontal"
        v-if="!hiddenHeader"
        theme="light"
        :active-name="tabOn"
        @on-select="selectUrl"
        class="header-wrap"
      >
        <div class="layout-nav">
          <MenuItem name="/" :style="font" to="/">
            首页
          </MenuItem>
          <MenuItem name="/order" :style="font" to="/order">
            我的订单
          </MenuItem>
          <MenuItem name="/sale_info" :style="font" to="/sale_info">
            购票须知
          </MenuItem>
          <MenuItem name="/park_notice" :style="font" to="/park_notice">
            园区公告
          </MenuItem>
          <MenuItem name="/user_info" :style="font" to="/user_info">
            个人中心
          </MenuItem>
        </div>
        <div class="header-operation-login" v-if="!loginShow">
          <div class="login" @click="login">登录</div>
        </div>
        <div class="header-operation" v-else>
          <div class="connect" @click="toPersonal">
            <Icon type="ios-contact" size="24"/>
            <!-- <div>
              <img
                :src="headimgurl"
                width="35px"
                height="35px"
                style="border-radius:18px"
              />
            </div> -->
            <div>{{ nickname | ellipsis }}</div>
          </div>
          <div class="logout" @click="logout">
            <Icon type="md-log-out" size="22" />
            退出
          </div>
        </div>
      </Menu>
    </div>
    <!-- 登陆框 -->
    <!-- <Modal
          :value="showModal"
          :footer-hide="true"
          :closable="true"
          :mask-closable="true"
          @on-visible-change="changeModal"
          class-name="vertical-center-modal">
          <p slot="header" style="height:40px;vartical-align:middle">
              <img src="img/logo.png" style="width:100px">
              <span style="margin-left:20px">* 扫码登录</span>
          </p>
          <div style="text-align:center;margin-bottom:20px">
              <Login @closeModal="closeModal" v-if="showModal"></Login>
          </div>
      </Modal> -->
    <!-- /登陆框 -->
  </div>
</template>

<script>
import Vue from "vue";
import api from "@/api";
import Login from "@/components/login/login.vue";
import { httpAction } from "@/api/manage";
import { mapState, mapActions } from "vuex";
export default {
  inject: ["reload"],
  components: {
    // calendar,
    Login
  },
  data() {
    return {
      data: [],
      nickname: "",
      headimgurl: "",
      showModal: false,
      tabOn: "/",
      font: {
        "font-size": "14px",
        "min-width": "120px",
        "text-align": "center",
        border: "none"
      },
      loginShow: false,
      hiddenHeader: false
    };
  },
  computed: {
    ...mapState({
      hasUser: state => state.token
    }),
    username() {
      return this.$store.state.username;
    }
  },
  watch: {
    hasUser: {
      deep: true,
      handler(newVal, oldVal) {
        if (newVal) {
          this.handleLoginStatus();
          // this.getUserName()
        }
      }
    },
    $route(to, from) {
      // console.log(to)
      if (to.path === '/order/' || to.path === '/order/presonal' || to.path === '/order'|| to.path === "/order/invoice" || to.path === '/order/detail/list' || to.path === '/order/myBookOrder' ||to.path === '/order/detail/myBookOrderDetail') {
        this.tabOn = '/order'
      } else if (to.path === '/sale_info') {
        this.tabOn = '/sale_info'
      } else if (to.path === '/park_notice' || to.path === '/park_notice/notice') {
        this.tabOn = '/park_notice'
      } else if (to.path === '/user_info/' || to.path === "/user_info/uorder" || to.path === '/user_info' || to.path === '/user_info/uinvoice') {
        this.tabOn = '/user_info'
      } else{
        this.tabOn = '/'
      }
      const routeType = this.$route.name;
      // console.log(routeType)
      if (routeType === "Login") {
        this.hiddenHeader = true;
      } else {
        this.hiddenHeader = false;
      }
    }
  },
  mounted() {
    this.handleLoginStatus();
    // if (Vue.ls.get('tabOn')) {
    //   this.tabOn = Vue.ls.get('tabOn')
    // }
    this.nickname = Vue.ls.get("nickname");
    this.headimgurl = Vue.ls.get("headimgurl");
    // this.$nextTick(() => {
    //   if (Vue.ls.get('token')) {
    //     this.getUserName()
    //   }
    // })
  },
  updated() {
    // this.handleLoginStatus()
  },
  created() {
    if (this.$route.path === "/") {
      this.tabOn = "/";
    } else if (this.$route.path === "/order") {
      this.tabOn = "/order";
    } else if (this.$route.path === "/sale_info") {
      this.tabOn = "/sale_info";
    } else if (this.$route.path === "/park_notice") {
      this.tabOn = "/park_notice";
    } else if (this.$route.path === "/user_info") {
      this.tabOn = "/user_info";
    }
  },
  filters: {
    // 用户名显示4位，超过4位显示...
    ellipsis: function(value) {
      if (!value) return "";
      if (value.length > 4) {
        return value.slice(0, 4) + "...";
      }
      return value;
    }
  },
  methods: {
    toHome() {
      this.$router.push("/");
      this.tabOn = "/";
      this.hiddenHeader = false;
    },
    handleLoginStatus() {
      const token = Vue.ls.get("token");
      if (token) {
        this.$set(this, "loginShow", true);
      } else {
        this.$set(this, "loginShow", false);
      }
      const routeType = this.$route.name;
      if (routeType === "Login") {
        this.hiddenHeader = true;
      } else {
        this.hiddenHeader = false;
      }
    },
    // async getUserName () {
    //   const obj = { }
    //   const res = await httpAction(api.userSelect, 'post', obj)
    //   this.$set(this, 'data', res.data)
    //   this.$store.dispatch('setUserName', this.nickname)
    // },
    login() {
      this.$set(this, "hiddenHeader", true);
      this.$forceUpdate();
      this.$router.push({
        path: "/login",
        query: { redirect: this.$route.fullPath }
      });
    },
    closeModal() {
      this.showModal = false;
      // this.reload()
      // console.log(this.showModal)
    },
    changeModal(val) {
      this.showModal = val;
    },
    selectUrl(name) {
      this.tabOn = name;
      Vue.ls.set("tabOn", this.tabOn);
    },
    toPersonal() {
      this.$router.push("/user_info");
      Vue.ls.set("tabOn", "/user_info");
      this.reload();
    },
    logout() {
      this.$Modal.confirm({
        title: "是否确认退出登录？",
        onOk: () => {
          if (Vue.ls.get("token")) {
            Vue.ls.remove("tabOn");
            Vue.ls.remove("token");
            Vue.ls.remove("refresh_token");
            Vue.ls.remove("type");
            Vue.ls.remove("group");
            Vue.ls.remove("temporary");
            this.$store.dispatch("setUserName", "");
            this.$router.push("/");
            this.$Message.success("退出成功");
            this.reload();
          }
          // else {
          //   this.$Message.error('请您重新登录')
          //    this.reload()
          // }
        },
        onCancel: () => {}
      });
    }
  }
};
</script>

<style scoped lang="less">
.header-content {
  background: #fff;
  display: flex;
  border-bottom: solid #ddd 1px;
  box-sizing: border-box;
}
.header {
  width: 1200px;
  margin: 0 auto;
  height: 80px;
  line-height: 80px;
  position: relative;
}
.logo-img {
  cursor: pointer;
  display: inline-block;
  position: absolute;
  top: 16px;
  left: 0;
  width: 131px;
  z-index: 999;
}
/* a:visited
{
  background-color:yellow;
} */
.logo {
  width: 150px;
}
.pc-name {
  float: left;
  color: @font-white;
  position: relative;
  left: 30px;
  font-size: 16px;
}
.pc-nav {
  width: 300px;
  margin: 0 auto;
  margin-right: 20px;
}
.layout-logo {
  width: 150px;
  height: 30px;
  float: left;
  position: relative;
  top: 10px;
  left: 20px;
}
.layout-nav {
  width: 600px;
  margin: 0 auto;
  margin-right: 300px;
}
.connect {
  width: 120px;
  display: flex;
  align-items: center;
  justify-content: space-around;
  cursor: pointer;
}
.connect:hover {
  color: @common;
}
.logout {
  cursor: pointer;
}
.logout:hover {
  color: @common;
}
.login {
  cursor: pointer;
}
.login:hover {
  color: @common;
}
.header-operation {
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: flex-end;
  /*left: 180px;*/
  height: 80px;
  line-height: normal;
  word-wrap: break-word;
  align-items: center;
}
.header-operation-login {
  display: flex;
  flex-direction: row;
  position: relative;
  justify-content: flex-end;
  /*left: 280px;*/
  height: 80px;
  line-height: normal;
  word-wrap: break-word;
  align-items: center;
}
.header-wrap {
  height: 80px;
  line-height: 80px;
  background-color: transparent !important;
}
.header-wrap::after {
  content: "";
  display: none !important;
}
</style>
